if($('footer#footer').length){
    $(document).on('click', 'footer#footer h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('footerActive')
    })
    $('.top-navigation-bar .container').append($('footer#footer .topStore').clone())
    $('#signature').attr('style', '').append('<div class="shippingAndDelivery">'+$('footer#footer .shippingAndDelivery').html()+'</div><span class="dostmedia"><a href="https://www.shoptet.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" class="title" target="_blank">Vytvořil Shoptet</a> | <a href="https://www.dostmedia.cz/" target="_blank">Dostmedia</a></span>')
}
else{
    $(document).ready(function() {
        var storeFooter = sessionStorage.getItem('storeFooter');
        if (storeFooter) {
            $('.top-navigation-bar .container').append(storeFooter);
        } else {
            $.ajax({
                url: '/',
                type: 'GET',
                success: function(responseData) {
                    var content = $(responseData);
                    sessionStorage.setItem('storeFooter', '<div class="topStore">'+content.find('.topStore').html()+'</div>');
                    $('.top-navigation-bar .container').append('<div class="topStore">'+content.find('.topStore').html()+'</div>');
                    var currentTime = new Date();
                    var currentDay = currentTime.getDay();
                    var currentHour = currentTime.getHours();
                    var currentMinutes = currentTime.getMinutes();
                    // Pracovní doba: 8:00 - 16:30
                    var openingTime = 8 * 60;
                    var closingTime = 16 * 60 + 30;
                    var currentMinutesSinceMidnight = currentHour * 60 + currentMinutes;
                    if (currentDay >= 1 && currentDay <= 5 && currentMinutesSinceMidnight >= openingTime && currentMinutesSinceMidnight <= closingTime) {
                        $('.openHours').addClass('open');
                    } else {
                        $('.openHours').addClass('closed');
                    }

                },
                error: function(xhr, status, error) {
                    console.error("Error fetching rating data:", status, error);
                }
            });
        }
      });
}